export function createSequentialQueue() {
  let pending = Promise.resolve();

  return function enqueue<T>(task: () => Promise<T>): Promise<T> {
    const run = pending.then(task, task);
    pending = run.then(
      () => undefined,
      () => undefined,
    );
    return run;
  };
}

export const enqueueOrganizationLookup = createSequentialQueue();
